import React from 'react';
import useMountedState from './useMountedState';

export type CancelablePromiseType = ReturnType<typeof useCancelablePromise>;

export default function useCancelablePromise<T = any>() {
	const isMounted = useMountedState();

	function getCancelablePromise<P = T | any>(promise: Promise<P>, onCancel?: VoidFunction) {
		// Wrap the given promise in a new promise
		return new Promise<P>((resolve, reject) => {
			promise
				.then(result => {
					// Only resolve the returned promise if mounted
					if (isMounted()) {
						// Resolve with the result of the wrapped promise
						resolve(result);
					}
				})
				.catch(error => {
					// Only reject the returned promise if mounted
					if (isMounted()) {
						// Reject with the error of the wrapped promise
						reject(error);
					}
				})
				.finally(() => {
					// Call the onCancel callback if not mounted
					if (!isMounted() && onCancel) {
						onCancel();
					}
				});
		});
	}

	return React.useCallback(getCancelablePromise, [isMounted]);
}
